import React, { Suspense } from 'react';
import LoadingIndicator from '../components/LoadingIndicator';

export default ({ children }) => (
  <div className="app">
    <Suspense fallback={<LoadingIndicator />}>
      { children }
    </Suspense>
  </div>
);